/* eslint-disable no-console */
import axios from 'axios'
import store from '@/store'
import { Notify } from 'vant';
// import { getToken } from '@/utils/auth'

// create an axios instance
let baseURL = 'https://pmtapi3.uelink.com.cn/pmtapi3';//正式
//let baseURL = 'https://pmtapi3.uelink.com.cn/pmtapi3Test';//测试

const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: baseURL,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            // config.headers['token'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 0) {
            Notify({
                message: res.msg || '网络错误，请重试',
                type: 'warning',
                duration: 3 * 1000
            })

            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Notify({
            message: '网络错误，请重试',
            type: 'warning',
            duration: 3 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
